import React, { useState, useEffect } from "react";
import { axiosReq, axiosReq2 } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { ChatSessionsTable, AddModalWriters, DeleteModalSession } from "../../components"
import AddModalAdmin from "../../components/MainAdmin/Modals/AddModalAdmin";
import SettingModal from "../../components/MainAdmin/Modals/SettingModal";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import AddModalSession from "../../components/MainAdmin/Modals/AddModalSession";
import { Link, useLocation } from "react-router-dom";

const ChatSessions = () => {
    const location = useLocation();


    const titleRow = ["نام", "نوع", "تاریخ شروع", "آخرین فعالیت"];
    const adminList = ["علی", "احمدی", "0020163258", "09120760563", "A1324", "A"]
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showSettingModal, setShowSettingModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [rags, setRags] = useState();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [id, setId] = useState(0);
    const [paginatedData, setPaginatedData] = useState([]); // For storing paginated results

    const itemsPerPage = 10;
    let navigate = useNavigate();

    const GetData = async () => {
        const cookies = new Cookies();
        console.log(66)
        // console.log(location.state.id)
        var ids = cookies.get('userConnectId');
        setId(ids)
        const writersData = await axiosReq2("user/chat?user_id=" + ids, "get");
        console.log(writersData)
        // setWritersList(writersData?.data)
        setCount(writersData.filter((x) => location.state?.type != "simple" ? x.rag_system_id == location.state?.id : x.rag_system_id == null).length)
        if (location.state?.type) {

            setWritersList(writersData.filter((x) => location.state?.type != "simple" ? x.rag_system_id == location.state?.id : x.rag_system_id == null).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))
            const startIndex = (page - 1) * row;
            const endIndex = startIndex + row;
            const currentPageData = writersData?.filter((x) => location.state?.type != "simple" ? x.rag_system_id == location.state?.id : x.rag_system_id == null).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).slice(startIndex, endIndex) || [];
            setPaginatedData(currentPageData);
        }
        else {
            setWritersList(writersData?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))
            const startIndex = (page - 1) * row;
            const endIndex = startIndex + row;
            const currentPageData = writersData?.slice(startIndex, endIndex) || [];
            setPaginatedData(currentPageData);
        }
        // setCount(writersData?.count)


        const datas = await axiosReq2("admin/rag_access/rag_systems?user_id=" + ids, "get");

        setRags(datas)
    }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/");
        }
        else {
            //     if( cookies.get('role')=="Admin")
            //    {

            GetData()
            //    }


            //     else {
            //         navigate("/admin");

            //     }
        }
    }
    useEffect(() => {

        auth();
    }, [reCheck, search, page, row,]);

    const addAdmin = async () => {

        // var res = allFull(allValues)
        // console.log(res)
        // if (res) {

        const dataUser = await axiosReq2("user/chat/create", "post", {
            name: new Date(),
            // llm_type:"rag",
            llm_type: location?.state?.type,
            user_id: id,
            // rag_system_id: allValues.RagId!=0?allValues.RagId:type=="simple"?null:rragid
            rag_system_id: location?.state?.id ? location?.state?.id : null

        });
        console.log(dataUser)
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            setRecheck(!reCheck)
            // setShowModal(false)
            // setData(dataUser?.data)
            alert("موفقیت آمیز");

        }
        else {
            console.log(dataUser)
            // setEroor(dataUser?.data)

            // setShowErrorModalStep1(true);
        }



    }
    // const currentItems = writersList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">نشست ها</p>
                </div>
                <div className="flex justify-start items-center">
                    {/* <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e) => setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div> */}
                    {/* <button className="w-[121px] h-[40px] hoverBgYellow bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button> */}
                    {/* <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center "> */}
                    <button onClick={() => addAdmin()} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن نشست جدید</p>
                    </button>
                    <button onClick={() => setShowAddModal(true)} className="w-[250px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن نشست جدید با نام دلخواه</p>
                    </button>
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <ChatSessionsTable detail={true} edit={false} block={false} deleted={true} setting={false}
                    setShowEditModal={setShowEditModal} setShowBlockModal={setShowBlockModal}
                    setShowDeleteModal={setShowDeleteModal}
                    data={data} setData={setData}
                    setShowSettingModal={setShowSettingModal}
                    titleRow={titleRow} writersList={paginatedData}
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} /></div>


            {showAddModal ? <AddModalSession title={'افزودن نشست جدید'} buttonName={'ثبت'} setShowModal={setShowAddModal} reCheck={reCheck} setRecheck={setRecheck}
                setSettingModal={setShowSettingModal} setData={setData} id={id} type={location?.state?.type} ragId={location?.state?.id} rags={rags} rragid={location?.state?.id} /> : null}
            {showEditModal ? <AddModalSession title={'ویرایش'} buttonName={'ویرایش'} kind={"edit"} setShowModal={setShowEditModal} data={writersList} reCheck={reCheck} setRecheck={setRecheck} /> : null}
            {showDeleteModal ? <DeleteModalSession title={'حذف کاربر'} buttonName={'حذف'} text={'آیا از حذف نشست انتخاب شده اطمینان دارید ؟'} setShowModal={setShowDeleteModal} data={data} id={id} reCheck={reCheck} setRecheck={setRecheck} /> : null}
            {showSettingModal ? <SettingModal title={'مدیریت دسترسی'} buttonName={'ثبت'} setShowModal={setShowSettingModal} reCheck={reCheck} setRecheck={setRecheck} data={data} /> : null}

        </div>
    )
}

export default ChatSessions;